import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";

export class MachineDeleteNodesFromNodesetHandler {
  deleteNodesFromNodeset() {
    const initialStructureNodeset = getInitialStructureNodeset();
    const machineStructureNodeset = getMachineStructureNodeset();

    // this is a differnt bug that occurs if only root node is selected and gets deleted
    // was added because Cannot read properties of undefined (reading 'parent')
    // TypeError: Cannot read properties of undefined (reading 'parent') at countParentRecursionLevels
    // (webpack-internal:///./src/components/pages/flat-edit-structure-page/tree-components/tree-our-node/tree-view-array-from-map.tsx:43:19)
    if (
      machineStructureNodeset.selectedNodeIds.size !==
        machineStructureNodeset.flatMap.size &&
      // machineStructureNodeset.selectedNodeIds.has("ns=0;i=84") &&
      machineStructureNodeset.rootNode.selected
    ) {
      // check if all nodes have been selected and check if the Set contains the specific RootNode id
      // set RootNode selected false
      // Remove the id from selectedNodeIds so that root node is not being removed
      machineStructureNodeset.rootNode.selected = false;
      machineStructureNodeset.selectedNodeIds.delete(
        machineStructureNodeset.rootNode.id,
      );
    }

    // we check here if the root node is loaded yet (initial structure might still be loading)
    // if it is, we set the transferred attribute to false for all selected nodes in the initial structure nodeset
    // because they are being deleted from the machine structure nodeset and should not be transferred to the machine structure on save
    if (initialStructureNodeset.getRootNode()) {
      initialStructureNodeset.setTransferredAttributeOnSelectedNodes(
        false,
        machineStructureNodeset.selectedNodeIds,
      );
      initialStructureNodeset.setFlatMap(
        initialStructureNodeset.getRootNode().createMapFromOurNodeTree(),
      );
    }

    machineStructureNodeset.deleteNodesContainedInSelectedNodesSet();
  }
}
